import { useSelector } from "react-redux";
import { FirebaseState } from "../../utilities/firebaseState";
import { ProjectState } from "./slice";

export const useProjectState = () => {
    return useSelector(
        (state: { project: ProjectState; firebase: FirebaseState }) => state
    );
};
